import { useContext, useMemo } from 'react';
import { ReportWithOptions } from 'reporting-snowflake/relational/resolve/resolve-records';
import { createRelationalReportFromBaseReport } from 'reporting-snowflake/relational/utils/report-utils';
// @ts-expect-error untyped module
import { createDefaultReportOptions } from 'reporting-ui-components/components/snowflake/report-options';
// @ts-expect-error untyped module
import { useReportToQuery } from 'reporting-ui-components/components/snowflake/internal/queryUtils';
import { getName, getReportDescription } from 'reporting-data/report/reportGetters';
import { UserInfoContext } from 'reporting-data/userInfo/userInfoContext';
import { useTableDescriptionMeta } from 'reporting-snowflake/relational/metadata/table-description-meta';
import { convertReportToSummaryTable } from 'reporting-snowflake/relational/utils/summary-table-utils';
export function useSnowflakeSummaryTable(previewReport) {
  const userInfo = useContext(UserInfoContext);
  const reportDefinition = useMemo(() => createRelationalReportFromBaseReport(previewReport), [previewReport]);
  const reportWithOptions = useMemo(() => {
    return ReportWithOptions({
      reportDefinition,
      reportOptions: createDefaultReportOptions(reportDefinition, undefined)
    });
  }, [reportDefinition]);
  const {
    data: tableAndPropertyMeta
  } = useTableDescriptionMeta(reportDefinition.get('table'));
  const {
    reportDefinition: tableReportDefinition
  } = useReportToQuery(reportWithOptions, undefined) || {};
  return useMemo(() => {
    return tableReportDefinition && tableAndPropertyMeta && convertReportToSummaryTable({
      name: getName(previewReport),
      description: getReportDescription(previewReport),
      reportDefinition: tableReportDefinition,
      userInfo,
      tableAndPropertyMeta
    });
  }, [previewReport, tableReportDefinition, tableAndPropertyMeta, userInfo]);
}